import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=de2d1d1c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de2d1d1c')) {
      api.createRecord('de2d1d1c', component.options)
    } else {
      api.reload('de2d1d1c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=de2d1d1c&", function () {
      api.rerender('de2d1d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uAtIBOO0Bat4/JS/comp/ImgFallback2.vue"
export default component.exports